//export const API_URL = 'https://apisit.inon.vn'
export const API_URL = 'https://api.inon.vn'
//export const API_URL = 'https://apisit.inon.vn'
//export const API_PAY_CONSTRACT= '/nth/vehicleinsurance/api/contracts/pay-test'

export const API_PAY_CONSTRACT = '/nth/vehicleinsurance/api/contracts/pay'

export const API_GET_ROLES = 'API_GET_ROLES'

export const API_CHECK_INFO_CONTACT_BY_ID = '/nth/contactmanager/api/customers/check/'

export const API_CHECK_INFO_VEHICLE = '/nth/vehicleinsurance/api/vehicles/check/'

export const API_CREATE_VEHICLE = '/nth/vehicleinsurance/api/vehicles'

export const API_CREATE_CONSTRACT = '/nth/vehicleinsurance/api/contracts'

export const API_CREATE_CONTACT = '/nth/contactmanager/api/customers'

export const API_UPDATE_INSURANCE = '/nth/vehicleinsurance/api/insurances'

export const API_GET_CONTACT = '/nth/contactmanager/api/customers/'

export const API_UPDATE_INSURANCE_ADDONS = '/nth/vehicleinsurance/api/insurance-addons'

export const API_GET_CONSTRACT = '/nth/vehicleinsurance/api/contracts'

export const API_GET_CAR_MANUFACTURERS = '/nth/datacollection/api/car-manufacturers'

export const API_GET_ALL_BANK = '/nth/datacollection/api/allBanks'

export const API_GET_CAR_VEHICLE = '/nth/vehicleinsurance/api/vehicle-types/car'

export const API_GET_CONTACT_BY_CONTRACTID = '/nth/vehicleinsurance/api/contract/owner'

export const API_GET_CONTRACT_FEE = '/nth/vehicleinsurance/api/contracts/fee'

export const API_COMPLETE_CONSTRACT = '/nth/vehicleinsurance/api/contracts/additional'

export const API_GET_CITY = '/nth/datacollection/api/cities'

export const API_GET_DISTRICTS = '/nth/datacollection/api/districts'

export const API_GET_WARDS = '/nth/datacollection/api/wards'

export const API_APPROVED_CONSTRACT = '/nth/flowapproval/api/contract-approvals'

export const API_GET_CONSTRACTS_CAR_PENDING = '/nth/vehicleinsurance/api/contracts/approval/pending/CC'

export const API_GET_CONSTRACTS_MOTOR_PENDING = '/nth/vehicleinsurance/api/contracts/approval/pending/MC?sort=id,DESC'
export const API_GET_BANK_TRANSFER_INFO = '/nth/insurancecompany/api/banks'

// export const API_GET_ROLES = 'http://localhost:8086/nth/accesscontrol/api/roles'
export const API_GET_ROLES1 = 'API_GET_ROLES'
export const API_CHECK_INFO_BY_ID = '/nth/contactmanager/api/customers/check/'

//export const API_CREATE_CONSTRACT= '/nth/vehicleinsurance/api/contracts'
//export const API_CREATE_CONTACT = '/nth/contactmanager/api/customers'
export const API_GET_CITI = '/nth/datacollection/api/cities'
export const API_GET_WARD = '/nth/datacollection/api/wards'
// export const API_GET_DISTRICTS = '/nth/datacollection/api/districts'
export const API_CHECK_NUMBERPLATE = '/nth/vehicleinsurance/api/vehicles/check/'
export const API_GET_MANUFACTURERS = '/nth/datacollection/api/moto-manufacturers'
// export const API_UPDATE_INSURANCE = '/nth/vehicleinsurance/api/insurances'
export const API_CHECK_CONTACT = '/nth/contactmanager/api/customers/check/'
export const API_GET_CONTRACT = '/nth/vehicleinsurance/api/contract/owner/'
export const API_UPDATE_CONTRACT = '/nth/vehicleinsurance/api/contracts'
export const API_GET_FEE = '/nth/vehicleinsurance/api/contracts/fee/'

export const API_GET_TYPE = '/nth/vehicleinsurance/api/vehicle-types/motor'

export const API_GET_BANK_COMPANY = '/nth/insurancecompany/api/banks'
export const API_UPLOAD_FILE = 'nth/file/api/upload'

export const API_GET_VEHICLE_TEMPLATE_LIST = '/nth/vehicleinsurance/api/contracts/temp?number=0&size=20'

export const API_CONFIRM_CONSTRACT = '/nth/vehicleinsurance/api/contracts/gpay/confirm' //  '/nth/payments/api/vnpay/confirm-payment'
export const API_API_TEST_PAY = '/nth/vehicleinsurance/api/contracts/pay-test/'


//export const API_PAY_CONSTRACT= '/nth/vehicleinsurance/api/contracts/pay'//apiSit


//export const API_PAY_CONSTRACT= 'nth/vehicleinsurance/api/contracts/pay-test'//apiTest

export const API_GET_CONSTRACTS_CAR_ALL = '/nth/vehicleinsurance/api/contract-manager/all-contracts/CC'

export const API_GET_CONSTRACTS_CAR_PARTNERS = '/nth/vehicleinsurance/api/contract-manager/partner-contracts/CC'

export const API_GET_CONSTRACTS_CAR_PERS = '/nth/vehicleinsurance/api/contract-manager/my-contracts/CC'


export const API_GET_CONSTRACTS_MOTO_ALL = '/nth/vehicleinsurance/api/contract-manager/all-contracts/MC'

//export const API_GET_CONSTRACTS_MOTO_ALL= '/nth/vehicleinsurance/api/contract-manager/all-contracts/MC?toDate=2021-01-26T00:00:00Z&fromDate=2021-01-24T00:00:00Z'

export const API_GET_CONSTRACTS_MOTO_PERS = '/nth/vehicleinsurance/api/contract-manager/my-contracts/MC'

export const API_GET_PARTNER = '/nth/user/api/child-users'

export const API_GET_MANAGE_SYSTEM_FEE = '/nth/vehicleinsurancefee/api/fee-manager'

export const API_UPDATE_MANAGE_SYSTEM_FEE_CAR = '/nth/vehicleinsurancefee/api/fee-manager/car/update'

export const API_UPDATE_MANAGE_SYSTEM_FEE_MOTOR = '/nth/vehicleinsurancefee/api/fee-manager/motor/update'

export const API_GET_MANAGE_SYSTEM_FEE_APRROVE = '/nth/vehicleinsurancefee/api/fee-manager/approval/01'

export const API_GET_MANAGE_SYSTEM_FEE_APRROVE_DETAIL = '/nth/vehicleinsurancefee/api/fee-manager'

export const API_APPROVE_MANAGE_SYSTEM_FEE = '/nth/vehicleinsurancefee/api/fee-manager/approval'

export const API_GET_CONFIG_ACCOUNT = '/nth/account/api/my-accounts'

export const API_GET_CONFIG_FEE_BHVC = '/nth/vehicleinsurancefee/api/bhvc/config/01'



